<template>
  <b-modal
    id="mod-split-bill"
    title="Split the Bill"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    @show="defaultPaymentLine()">
    <b-row>
      <b-col cols="1"></b-col>
      <b-col cols="3"><p>Line No.</p></b-col>
      <b-col cols="4"><p>Payment</p></b-col>
      <b-col cols="4"></b-col>
    </b-row>
    <b-row v-for="line of paymentLines" :key="line.line_number" class="py-1">
      <b-col cols="1">
        <a :href="'#'+$route.path" :hidden="line.paid"><b-icon icon="x-circle" variant="danger" font-scale="1.5" v-b-popover.hover.left="'Delete Line'" @click="deletePaymentLine(line.line_number)"></b-icon></a>
      </b-col>
      <b-col cols="3">{{ line.line_number }}</b-col>
      <b-col cols="4"><b-form-input :disabled="line.paid" v-model="line.line_total">$</b-form-input></b-col>
      <b-col cols="4" v-if="!line.paid">
        <b-button
         :disabled="paymentTotalAlert"
         variant="warning"
         v-b-modal.mod-payment-type
         @click="setSplitPaymentProperties(line.line_number, line.line_total)">
         Pay
       </b-button>
      </b-col>
      <b-col cols="4" v-else-if="line.paid">PAID</b-col>
    </b-row>
    <b-row class="py-2">
      <b-col>
        <b-button variant="primary" @click="addPaymentLine()">Add New Line</b-button>
      </b-col>
    </b-row>
    <hr>
    <b-row class="py-2">
      <b-col>Order Total: {{ splitOrderTotal | toCurrency }}</b-col>
      <b-col>Payment Total: ${{ payment_total }}</b-col>
    </b-row>
    <b-row class="py-2">
      <b-alert v-model="paymentTotalAlert" variant="danger">Total of payments exceed Order Total</b-alert>
    </b-row>
    <b-row class="py-2">
      <b-col><b-button :disabled="partiallyPaid" @click="closeSplitBill()" variant="dark">Back</b-button></b-col>
    </b-row>
  </b-modal>

</template>

<script>
export default {
  name: 'SplitBill',
  props: ['selectedOrderTotal','splitPaidDetails'],
  data () {
    return {
      paymentLines: [],
      paymentTotalAlert: false,
      splitPayment: {},
      splitOrderTotal: 0.00
    }
  },

  watch: {
    payment_total: function() {
      if (this.payment_total!=this.splitOrderTotal) {
        this.paymentTotalAlert = true;
      } else {
        this.paymentTotalAlert = false;
      }
    },

    // once a payment has been made on the server this prop is updated in Orders.vue. Update the payment lines to show as paid when match
    splitPaidDetails: function() {
      if (Object.keys(this.splitPaidDetails).length>0) {
        const line = this.paymentLines.filter(
          l=>l.line_number==this.splitPaidDetails.Line && l.line_total==this.splitPaidDetails.Amount
        );
        line[0].paid = true;
        this.$emit('emit-partially-paid', this.partiallyPaid);
      }
    },
  },

  computed: {
    payment_total: function() {
      var tot = 0;
      for (const l of this.paymentLines) {
        tot += Number(l.line_total);
      }
      return Number(Math.round(tot*100) / 100).toFixed(2);
    },

    partiallyPaid: function() {
      const split_paid = this.paymentLines.filter(l=>l.paid==true);
      const split_unpaid = this.paymentLines.filter(l=>l.paid==false);
      // if there are paid & unpaid payment lines - it is partially paid
      if (split_paid.length>0 && split_unpaid.length>0) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    setSplitOrderTotal(line) {
      if (this.paymentLines.length>0) {
        this.splitOrderTotal = (Number(this.selectedOrderTotal) + (line*Number(0.50))).toFixed(2);
      } else {
        this.splitOrderTotal = this.selectedOrderTotal;
      }
    },

    defaultPaymentLine() {
      if (this.paymentLines.length==0) {
        this.addPaymentLine();
      }
    },

    addPaymentLine() {
      this.setSplitOrderTotal(this.paymentLines.length);
      const maxline = this.paymentLines.reduce(
        (max, line) => (line.line_number > max ? line.line_number : max), 0
      );
      const linetotal = Number(Math.round((this.splitOrderTotal - this.payment_total) * 100) / 100).toFixed(2);
      this.paymentLines.push({line_number:maxline+1, line_total:linetotal, paid: false})
    },

    deletePaymentLine(line_number) {
      this.paymentLines.splice(this.paymentLines.findIndex(l => l.line_number == line_number), 1);
      this.setSplitOrderTotal(this.paymentLines.length-1);
    },

    setSplitPaymentProperties(line_number, line_total) {
      // this.allowSplit=false;
      this.$emit('emit-split-payment', this.splitPayment);
      this.splitPayment.Line = line_number;
      this.splitPayment.Amount = line_total;
    },

    closeSplitBill() {
      this.$bvModal.hide('mod-split-bill');
      this.$emit('emit-close-split-modal');
    }
  },

  mounted() {
    this.$bvModal.show('mod-split-bill');
    this.setSplitOrderTotal(0);
  }
}
</script>

<style>

</style>
